const ALIAS = 'api';

export function searchForZonesByCoordinates() {
    return axios.post(`${ALIAS}/searchForZonesByCoordinates`, this.$root.addr.coordinates);
}
